import React, { useState } from 'react';

import SvgChevronDown from '../../static/images/chevron_down.svg';
import SvgChevronUp from '../../static/images/chevron_up.svg';
import style from './index.module.css';

type Props = {
    name: React.ReactNode;
    description?: React.ReactNode;
    open?: boolean;
    children: React.ReactNode;
};

export const Accordion = ({ name, description, children, open: openDefault = false }: Props): React.ReactElement => {
    const [open, setOpen] = useState(openDefault);

    return (
        <div className={style.accordion}>
            <div className={style.header} onClick={(): void => setOpen(!open)}>
                <div className={style.name}>{name}</div>
                <div className={style.description}>
                    {description}
                    {open ? <SvgChevronUp /> : <SvgChevronDown />}
                </div>
            </div>
            {open && <div className={style.body}>{children}</div>}
        </div>
    );
};
